import React, { useEffect, useState } from 'react';
import dictionary from '../util/dictionary';


const ThemeContext = React.createContext();

export const ThemeConsumer = ThemeContext.Consumer;

export const ThemeProvider = (props) => {

    const [refreshRate, setRefreshRate] = useState(1);
    const [tableRowCount, setTableRowCount] = useState(0);
    const [tableDetected, setTableDetected] = useState(false);
    // const [viewAsRole, setViewAsRole] = useState("Normal View")


    useEffect(() => {

        setTimeout(() => {
            setRefreshRate(refreshRate + 1)
        }, dictionary._uiRefreshRate);

    }, [refreshRate])

    useEffect(() => {
        detectDataTable();
    }, [refreshRate])


    // useEffect(() => {
    //     refreshDatatable()
    // }, [tableRowCount])

    const detectDataTable = () => {
        var tableElement = document.getElementsByClassName("datatable");
        // var emptyElement = document.getElementsByClassName("dataTables_empty");

        if (tableElement.length > 0) {
            setTableRowCount(document.getElementsByTagName("tbody")[0].rows.length)
            setTableDetected(true)
            // console.log("Datatable detected with " + numRows + " data row(s)")
            // beautifyTable(tableElement[0].getAttribute('id'), true, false)
        }else{
            setTableDetected(false)
        }
    }

    




    return (
        <ThemeContext.Provider
        value={{
            tableDetected,
            // viewAsRole,
          tableRowCount,
            // setViewAsRole
        }}
        >
            {props.children}
        </ThemeContext.Provider>
    );
}


export default ThemeContext;